import React, { useState } from 'react';

const UploadImage = () => {
  // وضعیت‌های فرم و خطاها
  const [productId, setproductId] = useState('100');
  const [codeSpeed, setcodeSpeed] = useState('100');
  const [groupId, setgroupId] = useState('101');
  const [name, setName] = useState('');
  const [description, setDescription] = useState('');
  const [price, setPrice] = useState('');
  const [images, setImages] = useState([]); 
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(null);

 
  const handleSubmit = async (e) => {
    e.preventDefault();

    // بررسی وجود فایل تصویر
    if (images.length === 0) {
      setError('لطفاً حداقل یک تصویر انتخاب کنید.');
      return;
    }

 
    const formData = new FormData();
    formData.append('productId', productId);
    formData.append('codeSpeed', codeSpeed);
    formData.append('groupId', groupId);
    formData.append('name', name);
    formData.append('description', description);
    formData.append('price', price);

    // اضافه کردن تمام تصاویر به formData
    images.forEach(image => {
      formData.append('images', image);
    });


    try {
      const response = await fetch('https://api2.raynogroup.com/api/upload', {
        method: 'POST',
        body: formData,
      });

      console.log(formData);
      if (!response.ok) {
        const errorData = await response.json();
        setError(`خطا: ${errorData.error}`);
        setSuccess(null); 
      } else {
        const result = await response.json();
        setSuccess(`محصول با موفقیت اضافه شد: ${JSON.stringify(result)}`);
        setError(null);
        resetForm();
      }
    } catch (err) {
      setError('خطای داخلی در ارسال اطلاعات.');
      setSuccess(null);
    }
  };

  const resetForm = () => {
    setproductId('');
    setcodeSpeed('');
    setgroupId('');
    setName('');
    setDescription('');
    setPrice('');
    setImages([]); // پاک کردن تصاویر پس از ارسال
  };

  const handlePriceChange = (e) => {
    const value = e.target.value;
    if (/^\d*\.?\d*$/.test(value)) { 
      setPrice(value);
    }
  };

  const handleImageChange = (e) => {
    setImages(Array.from(e.target.files)); 
  };
  return (
    <div className="container mt-5">
      <h2 className="mb-4 text-center">فرم آپلود محصول</h2>
      <form onSubmit={handleSubmit} className="needs-validation" noValidate>
        <div className="mb-3">
          <label htmlFor="name" className="form-label">نام محصول:</label>
          <input
            type="text"
            className="form-control"
            id="name"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="description" className="form-label">توضیحات:</label>
          <textarea
            id="description"
            className="form-control"
            value={description}
            onChange={(e) => setDescription(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="codeSpeed" className="form-label">کد محصول:</label>
          <input
            type="text"
            className="form-control"
            id="codeSpeed"
            value={codeSpeed}
            onChange={(e) => setcodeSpeed(e.target.value)}
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="price" className="form-label">قیمت محصول:</label>
          <input
            type="text" // نوع ورودی را به "text" تغییر دادیم
            className="form-control"
            id="price"
            value={price}
            onChange={handlePriceChange} // از تابع جدید برای اعتبارسنجی ورودی استفاده می‌کنیم
            required
          />
        </div>

        <div className="mb-3">
          <label htmlFor="images" className="form-label">انتخاب تصاویر:</label>
          <input
            type="file"
            className="form-control"
            id="images"
            accept="image/jpeg, image/png, image/gif"
            onChange={handleImageChange}
            multiple // ویژگی multiple برای انتخاب چندین فایل
            required
          />
        </div>

        <div className="text-center">
          <button type="submit" className="btn btn-primary">ارسال</button>
        </div>
      </form>

      {error && <div className="alert alert-danger mt-3" role="alert">{error}</div>}
      {success && <div className="alert alert-success mt-3" role="alert">{success}</div>}
    </div>
  );
};

export default UploadImage;
